import { HpDynamicButtonClickPayload } from '../engineClient/actions/dynamicButtonClickActionTypes';
import { HpEventPayload } from '../engineClient/actions/eventActionTypes';
import { triggerModalActionEvent } from '../engineClient/actions/eventActions';
import {
  HpAction,
  HpClientQuestion,
  HpCreateActionPromisesProps,
  HpDependentActionFunction,
  HpDispatchFunction
} from '../engineClient/types';

export interface HpToggleModalActionPayload extends HpToggleModalDependentActionPayload {
  toggle: boolean;
}

export interface HpToggleModalDependentActionPayload extends HpEventPayload {
  question: HpClientQuestion;
}

export type HpToggleModalActionAction = HpAction<HpToggleModalActionPayload>;

export type HpToggleModalActionDispatchFunction = (
  dispatch: HpDispatchFunction<HpToggleModalActionPayload>
) => Promise<void>;

/**
 * This is a dependent action used by the custom control modal.
 * It will toggle the modal on, and then off after the action is complete.
 * Do not use for standard modals.
 */
export function toggleModalDependentAction(
  properties: HpCreateActionPromisesProps
): HpDependentActionFunction<HpToggleModalDependentActionPayload> | undefined {
  const { payload, question } = properties;
  const { getEvent } = payload as HpDynamicButtonClickPayload;
  return toggleModalAction({ getEvent, question });
}

function toggleModalAction(
  payload: HpToggleModalDependentActionPayload
): (dispatch: HpDispatchFunction<HpToggleModalActionPayload>) => Promise<boolean> {
  const { getEvent, question } = payload;
  return (dispatch: HpDispatchFunction<HpToggleModalActionPayload>): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
      triggerModalActionEvent({ question, getEvent, buttonType: 'show' });
      dispatch({
        type: 'MODAL_TOGGLED' as any,
        payload: { toggle: true, getEvent, question }
      });

      resolve(true);
    }).finally(() => {
      dispatch({
        type: 'MODAL_TOGGLED' as any,
        payload: { toggle: false, getEvent, question }
      });
    });
  };
}
